import React, { lazy, Suspense } from 'react';
import { TextOverlay } from '../../types/promo';

interface PromoOverlayTextProps {
    textOverlay?: TextOverlay | null;
}

const PromoOverlayHtml = lazy(() => import('./PromoOverlayHtml'));

// Shared between the admin/partner live preview canvas and the actual served
// PromoContent component so the preview matches exactly how the promo renders.
const PromoOverlayText: React.FC<PromoOverlayTextProps> = ({ textOverlay }) => {
    if (!textOverlay?.enabled || !textOverlay.html) return null;

    return (
        <Suspense fallback={null}>
            <PromoOverlayHtml textOverlay={textOverlay} />
        </Suspense>
    );
};

export default PromoOverlayText;
